/** The browser tab's name: alone on a route without a title, after the page name on the others. */
export const APP_TITLE = 'Brooch CRM';

/** Between the page name and {@link APP_TITLE}. */
export const APP_TITLE_SEPARATOR = ' · ';
